import {
  IEditVasRatePayload,
  IGetVasRateList,
  IVasRateCreate,
  IVasRateDetails,
  IVasRateListSearch,
} from "../../../types/master/vasRateInterface";
import { VasRateActionTypes, VasRateActions } from "../../actionTypes/master/vasRateActionTypes";

export const createVasRate = (payload: IVasRateCreate): VasRateActionTypes => ({
  type: VasRateActions.CREATE_VAS_RATE,
  payload,
});

export const getVasRateList = (payload: IVasRateListSearch): VasRateActionTypes => ({
  type: VasRateActions.GET_VAS_RATE_LIST,
  payload,
});

export const setVasRateList = (vasRateList: Array<IGetVasRateList>): VasRateActionTypes => ({
  type: VasRateActions.SET_VAS_RATE_LIST,
  payload: vasRateList,
});

export const setVasRateListPageCount = (payload: number): VasRateActionTypes => ({
  type: VasRateActions.SET_VAS_RATE_LIST_PAGE_COUNT,
  payload,
});

export const getVasRateDataById = (id: number | string): VasRateActionTypes => ({
  type: VasRateActions.GET_VAS_RATE_DATA_BY_ID,
  payload: id,
});

export const setVasRateDataById = (payload: IVasRateDetails): VasRateActionTypes => ({
  type: VasRateActions.SET_VAS_RATE_DATA_BY_ID,
  payload,
});

export const editVasRate = (payload: IEditVasRatePayload): VasRateActionTypes => ({
  type: VasRateActions.EDIT_VAS_RATE_DATA_BY_ID,
  payload,
});
